module.exports = __webpack_public_path__ + "static/media/River_Plumb.50e99446.webp";